/* tslint:disable */
/* eslint-disable */
/* @relayHash 1712385ff4b2375b495a3c07ac28fe34 */

import { ConcreteRequest } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "COMMENT_SEEN" | "CONFIGURE_PUBLIC_PROFILE_URL" | "DEFAULT_QA_STORY_MODE" | "DISABLE_LIVE_UPDATES" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "EMAIL_META" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "VIEWER_COUNT" | "Z_KEY" | "%future added value";
export type SearchStoryFetchQueryVariables = {
    query: string;
    limit: number;
    siteIDs?: Array<string> | null;
};
export type SearchStoryFetchQueryResponse = {
    readonly settings: {
        readonly multisite: boolean;
        readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    };
    readonly stories: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly site: {
                    readonly name: string;
                    readonly id: string;
                };
                readonly metadata: {
                    readonly title: string | null;
                    readonly section: string | null;
                    readonly author: string | null;
                } | null;
            };
        }>;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
        };
    };
};
export type SearchStoryFetchQuery = {
    readonly response: SearchStoryFetchQueryResponse;
    readonly variables: SearchStoryFetchQueryVariables;
};



/*
query SearchStoryFetchQuery(
  $query: String!
  $limit: Int!
  $siteIDs: [ID!]
) {
  settings {
    multisite
    featureFlags
    id
  }
  stories(query: $query, first: $limit, siteIDs: $siteIDs) {
    edges {
      node {
        id
        site {
          name
          id
        }
        metadata {
          title
          section
          author
        }
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteIDs"
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "multisite",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "featureFlags",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "limit"
            },
            {
                "kind": "Variable",
                "name": "query",
                "variableName": "query"
            },
            {
                "kind": "Variable",
                "name": "siteIDs",
                "variableName": "siteIDs"
            }
        ],
        "concreteType": "StoriesConnection",
        "kind": "LinkedField",
        "name": "stories",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "StoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Story",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Site",
                                "kind": "LinkedField",
                                "name": "site",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    (v5 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryMetadata",
                                "kind": "LinkedField",
                                "name": "metadata",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "section",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "author",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "SearchStoryFetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v6 /*: any*/)
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "SearchStoryFetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v6 /*: any*/)
            ]
        },
        "params": {
            "id": "1712385ff4b2375b495a3c07ac28fe34",
            "metadata": {},
            "name": "SearchStoryFetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'fc8e228472ee8960fe5d2ed6f2a6f268';
export default node;
